<template>
  <div>
    <div v-if="!isDeleteTriggered">
      <div class="sd-comment-img-container">
        <img :src="comment.image" class="img-fluid sd-comment-img">
        <div class="sd-comment-overlay">
          <div class="row no-gutters sd-comment-overlay-text">
            <div class="col-8">
              <div class="pl-2 sd-font-xs text-white text-capitalize">Created by: {{comment.user_name}} </div>
              <!-- <div class="sd-font-xs">{{ getDateString(comment.created_time) }}</div> -->
            </div>
            <div class="col-4 text-right">
              <a @click="openComment(comment)"
                class="sd-font-xs text-white pr-2 sd-cursor-pointer">
                <img src="@/assets/img/open_project.svg" width="15" class="pr-1" >Open
              </a>
            </div>
          </div>
        </div>
      </div>
      <div v-if="ensureDelete">
        <p class="sd-font-sm pl-2">Are you sure to delete comment ?</p>
        <a class="sd-font-xs text-primary p-3 sd-comment-button" @click="deleteConfirmation()">Ok</a>
        <a class="sd-font-xs text-primary p-3 sd-comment-button" @click="ensureDelete = false">Cancel</a>
      </div>
      <div v-else-if="ensureResolve">
        <p class="pl-2">Are you sure to resolve the comment ?</p>
        <a class="sd-font-xs text-primary p-3 sd-comment-button" @click="triggerCommentResolve()">Ok</a>
        <a class="sd-font-xs text-primary p-3 sd-comment-button" @click="ensureResolve = false">Cancel</a>
      </div>
      <div v-else>
        <div
          v-if="!isEditEnabled"
          class="sd-font-sm sd-bg--gray mt-1 p-2 rounded">{{comment.text}}
        </div>      
        <div>    
          <div v-if="!isEditEnabled" class="sd-font-xs badge-pill text-capitalize badge badge-light">{{comment.priority}}</div>      
          <div v-if="commentCategory && !isEditEnabled" class="sd-font-xs badge-pill badge badge-light  mr-1">{{commentCategory}}</div>          
        </div>
      </div>

      <div v-if="isEditEnabled">
        <div v-if="!isEditTriggered">
          <textarea class="form-control form-control-sm sd-font-xs mt-1" v-model="commentText"> </textarea>          
          <div class="row no-gutters pt-1" v-if="!comment.resolve">
            <div class="col-6 pr-2">
              <select
                class="form-control form-control-sm sd-font-xs p-0 border-0"
                v-model="comment.priority">              
                <option value="null" disabled>Select Priority</option>
                <option value="high">High</option>
                <option value="medium">Medium</option>
                <option value="low">Low</option>
              </select>
            </div>
            <div class="col-6">            
              <select class="form-control form-control-sm sd-font-xs p-0 border-0" v-model="commentCategory">
                <option value="null" disabled>Select Category</option>
                <option v-for="category in commentCategories" :key="category.id" :value="category.category">
                  {{category.category}}
                </option>
              </select>
            </div>      
          </div>
          <a class="btn btn-primary btn-sm sd-font-xs ml-0" @click="triggerCommentEdit()">Update</a>
          <a
            class="btn btn-outline-primary btn-sm sd-font-xs"
            @click="isEditEnabled = !isEditEnabled">Cancel</a>     
        </div>
        <div v-else-if="isEditTriggered">
          <div class="sd-font-sm sd-bg--gray mt-1 p-2 rounded">Updating Isssue....</div>
        </div>
      </div>
      <hr>
      <div class="row no-gutters">
        <div class="col-4 text-center">
          <a
            v-if="!comment.resolve"
            class="sd-font-xs text-primary p-2 sd-comment-button"
            @click="ResolveComment()">
            <img src="@/assets/img/orange_tick_mark.svg" width="15" class="pr-1">
            <span v-if="!isResolveTriggered">
              Resolve
            </span>
            <span v-else-if="isResolveTriggered">
              Resolving..
            </span>
          </a>
          <span v-if="comment.resolve" @click="triggerCommentResolve()" class="sd-font-xs text-primary p-2 sd-comment-button">Unresolve</span>
        </div>
        <div class="col-4 text-center">
          <a class="sd-font-xs text-primary p-3 sd-comment-button" @click="enableEdit()">
            <img src="@/assets/img/comments_icon_orange.svg" height="15" class="pr-1" >Edit
          </a>
        </div>
        <div class="col-4 text-center">
          <a class="sd-font-xs text-primary p-3 sd-comment-button" v-if="isDeleteEnabled" @click="deleteComment()">
            <img src="@/assets/img/delete_orange.svg" height="12" class="pr-1" alt="">Delete
          </a>
        </div>
      </div>
      <hr>
    </div>
    <div v-else-if="isDeleteTriggered && !isCommentDeleted">
      <p>Deleting Issue...</p>
    </div>
    <div v-else-if="isCommentDeleted">
      <p>Issue Successfully Deleted</p>
    </div>
    <!-- Zoom Viewer -->
    <div style='display: none'>
      <div ref='zoomViewer'>
        <img :src="generateImageSrc()">
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api';
import { POSITION_TIME_DATA_SETTERS } from '@/config';
import { getClosestIndexFromTime } from '@/utils/posDataOperations';
import { mapMutations, mapState, mapActions } from 'vuex';
import Viewer from 'viewerjs';


export default {
  props: ['comment', 'isDeleteEnabled'],
  data() {
    return {
      isEditEnabled: false,
      isDeleteTriggered: false,
      isCommentDeleted: false,
      isResolveTriggered: false,
      commentText: this.comment.text,
      isEditTriggered: false,
      commentCategory:'',
      ensureDelete: false,
      ensureResolve:false,
    }
  },
  mounted() {
    this.getCategoryFromId(this.comment.category);
    this.viewer = new Viewer(this.$refs.zoomViewer);
  },
  computed: {
    ...mapState([
      'positionTimeData',
      'projectDids',
      'commentCategories'
    ]),
  },
  methods: {
    ...mapActions([
      'retrieveComments',
    ]),
    ...mapMutations([
      'setGlobalPosData',
      'setCurrentDid',
      'setMapCoords',
    ]),
    generateImageSrc() {
        return this.comment.image;
        // console.log(this.commentImage);
        let imageObject = [];
        imageObject.push(this.commentImage);
        const imageSrc = window.URL.createObjectURL(new Blob(imageObject, {type: "application/zip"}));
        return imageSrc;
      return 'null';
    },
    getCategoryFromId( category ) {      
      Array.from(this.commentCategories).forEach((comment) => {
        if(comment.id == category) {
          this.commentCategory = comment.category;          
        }
      });
    },
     ResolveComment(){
      this.ensureResolve=true;
      if ( this.isEditEnabled ) {
        this.isEditEnabled = false;
      }  
      if(this.ensureDelete)
      {
        this.ensureDelete=false;
      }
    },
    deleteComment() {
      this.ensureDelete = true;    
      if ( this.isEditEnabled ) {
        this.isEditEnabled = false;
      }     
      if(this.ensureResolve){
        this.ensureResolve=false;
      } 
  
    },    
    enableEdit() {      
      this.isEditEnabled = !this.isEditEnabled;
      if ( this.ensureDelete ) {
        this.ensureDelete = false;
      }
       if(this.ensureResolve){
        this.ensureResolve=false;
      }

    },
    deleteConfirmation() {
      this.isDeleteTriggered = true;
      this.isCommentDeleted = false;     
      api.deleteComments(this.comment.comment_id, this.comment.subsection_data).then((response) => {
        if (response.status === 204) {
          this.isCommentDeleted = true;
          // Instead of retrieving comments again just remove that marker 
          this.retrieveComments(this.comment.subsection_data);
        } else {
          // FIXME: Handle Error
        }
      });
    },
    openComment(comment) {
      const data_type = this.projectDids[Number(comment.subsection_data)];
      if (data_type == 'video') {
        const posData = {
          lat: comment.latitude,
          lng: comment.longitude,
          setter: POSITION_TIME_DATA_SETTERS.POPUP,
        };
        // TODO: Close the comment popup or dropdown here.
        // TODO: Set video time to correct video time here.
        // There are a lot of videos that loiter around the same
        // point for a long time. This will cause an issue as the
        // comment time saved will be different, and the video will
        // be opened at a different time
        this.setGlobalPosData(posData);
        this.setCurrentDid(comment.subsection_data);
        this.$root.$emit('playvideo');
        this.$root.$emit('pausevideo'); 
      } else if (data_type == 'image') {
        // Open image viewer
        this.viewer.show();
        this.setMapCoords({lat: comment.latitude, lng: comment.longitude})
      } else if (data_type == 'layer') {
        // set view of main map
        this.setMapCoords({lat: comment.latitude, lng: comment.longitude})
      } else {
      }
    },
    triggerCommentResolve() {
       this.ensureResolve=false;
      if ( this.comment.resolve ) {
        this.isResolveTriggered = false;
      } else {
        this.isResolveTriggered = true;
      }
      api.updateComment(this.comment.comment_id, {
        resolve: this.isResolveTriggered,
      }).then((response) => {
        if(response.status === 200) {
          this.comment.resolve = this.isResolveTriggered;
        } else {
          // FIXME: Handle Error
        }
      });
    },
    triggerCommentEdit() {
      this.isEditTriggered = true;
      let data='';      
      if( this.comment.resolve ) {
        data = {
          text: this.commentText
        }
      } else {
        let id='';      
        Array.from(this.commentCategories).forEach((comment) => {      
          if(comment.category == this.commentCategory) {        
            id = comment.id;          
          }
        });
        data = {
          text: this.commentText,        
          priority: this.comment.priority,
          category: [id]
        }
      }
      api.updateComment(this.comment.comment_id, data).then((response) => {
        if(response.status === 200) {
          this.comment.text = this.commentText;
          this.isEditEnabled = false;
          this.isEditTriggered = false;
        } else {
          // FIXME: Handle Error
        }
      });
    }
  },
}
</script>

<style lang="scss">

.sd-comment-img-container {
  position:relative;
  max-width: 100%;
  height: auto;
  // display:inline-block;
  .sd-comment-img {
    object-fit: cover;
    border-radius: .2rem !important;
  }

  .sd-comment-overlay {
    position: absolute;
    top:0;
    left:0;
    width:100%;
    height:100%;
    border-radius: .2rem;
    background: linear-gradient(rgba(0,0,0,0), rgba(0,0,0,.6));
    .sd-comment-overlay-text {
      position: relative;
      top: 80%;
    }
  }
}
</style>
